import "url-polyfill";
import fromEntries from "object.fromentries";
import Vue from "vue";
import Vuex from "vuex";
import VueLazyload from "vue-lazyload";
import BootstrapVue from "bootstrap-vue";
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
} from "@fortawesome/vue-fontawesome";
import { config } from "@fortawesome/fontawesome-svg-core";
import * as Sentry from "@sentry/browser";
import vClickOutside from "v-click-outside";
import { createUniqIdsMixin } from "vue-uniq-ids/dist/vue-uniq-ids.min";
import WebAccount from "spiritweb.packages.web-account";
import Ecommerce, { GtagPlugin } from "spiritweb.packages.ecommerce";
import VueScrollTo from "vue-scrollto";
import LogRocket from "logrocket";
import store from "~/Scripts/store";
import "~/Styles/components/breadcrumb.less";
import MiniBasket from "~/Components/Basket/MiniBasket.vue";
import MegaMenu from "~/Components/MegaMenu.vue";
import QuickSearch from "~/Components/Search/QuickSearch.vue";
import HtmlEmbed from "~/Components/Base/HtmlEmbed.vue";
import DefaultModal from "~/Components/Base/DefaultModal.vue";

import "spiritweb.packages.ecommerce/dist/spiritweb.packages.ecommerce.min.css";
import "spiritweb.packages.web-account/dist/spiritweb.packages.web-account.min.css";

if ( !Object.fromEntries ) {
  // Add fromEntries polyfil
  fromEntries.shim();
}

config.autoReplaceSvg = false;
config.observeMutations = false;

Vue.use( Vuex );
Vue.use( BootstrapVue );
Vue.use( VueLazyload );
Vue.use( vClickOutside );
Vue.use( WebAccount, { store } );
Vue.use( GtagPlugin );
Vue.use( Ecommerce, { sentry: { dsn: "https://788739c88771487c8b2bfebeaa56a9df@o351484.ingest.sentry.io/5687137" } } );

Vue.component( "font-awesome-icon", FontAwesomeIcon );
Vue.component( "font-awesome-layers", FontAwesomeLayers );
Vue.component( "mini-basket", MiniBasket );
Vue.component( "mega-menu", MegaMenu );
Vue.component( "quick-search", QuickSearch );
Vue.component( "html-embed", HtmlEmbed );
Vue.component( "default-modal", DefaultModal );

const uniqIdsMixin = createUniqIdsMixin();
Vue.mixin( uniqIdsMixin );

const elr = document.querySelector( "meta[name=\"elr\"]" ).getAttribute( "content" ) === "true";
const lrp = document.querySelector( "meta[name=\"lrp\"]" ).getAttribute( "content" );

const environment = document.querySelector( "meta[name=\"environment\"]" ).getAttribute( "content" );
Vue.prototype.$environment = environment;

const version = document.querySelector( "meta[name=\"version\"]" ).getAttribute( "content" );
Vue.prototype.$version = version;

const packageString = document.querySelector( "meta[name=\"package\"]" ).getAttribute( "content" );
Vue.prototype.$package = packageString;

const evdt = document.querySelector( "meta[name=\"evdt\"]" ).getAttribute( "content" ) === "true";
if ( evdt ) {
  Vue.config.devtools = true;
}

Vue.use( VueScrollTo, {
  container: "#app",
} );

if ( process.env.NODE_ENV === "production" ) {
  if ( elr ) {
    LogRocket.init( lrp );
  }

  LogRocket.getSessionURL( sessionURL => {
    Sentry.configureScope( scope => {
      scope.setExtra( "sessionURL", sessionURL );
    } );
  } );
}

const csrfToken = document.querySelector( "meta[name=\"csrf-token\"]" ).getAttribute( "content" );
Vue.prototype.$csrfToken = csrfToken;
